import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Checkbox, Form } from "semantic-ui-react";

import { PasswordInput } from "../../components";

class XentryDealerSettings extends Component {
  handleCheckboxChange = (_e, data) => this.props.onUpdateDealer({ ...this.props.dealer, [data.name]: data.checked });

  handleInputChange = (_e, data) => this.props.onUpdateDealer({ ...this.props.dealer, [data.name]: data.value });

  render() {
    const { dealer, t } = this.props;

    return (
      <Form>
        <Form.Field style={{ marginLeft: "4px", marginRight: 0, maxWidth: "100%" }}>
          <Checkbox
            checked={dealer.is_xentry_enabled}
            name="is_xentry_enabled"
            label={t("xentry_enabled").message || "Xentry Enabled"}
            onChange={this.handleCheckboxChange}
          />
        </Form.Field>
        {dealer.is_xentry_enabled && (
          <>
            <Form.Field className="full-width-input">
              <label>{t("xentry_client_id").message || "Xentry client ID"}</label>
              <PasswordInput
                value={dealer.xentry_client_id}
                placeholder={t("xentry_client_id").message || "Xentry client ID"}
                name="xentry_client_id"
                showAsteriskPlaceholder={dealer.has_kms_encrypted_xentry_client_id}
                onChange={this.handleInputChange}
              />
            </Form.Field>

            <Form.Field className="full-width-input">
              <label>{t("xentry_client_secret").message || "Xentry client secret"}</label>
              <PasswordInput
                value={dealer.xentry_client_secret}
                placeholder={t("xentry_client_secret").message || "Xentry client secret"}
                name="xentry_client_secret"
                showAsteriskPlaceholder={dealer.has_kms_encrypted_xentry_client_secret}
                onChange={this.handleInputChange}
              />
            </Form.Field>
          </>
        )}
      </Form>
    );
  }
}

export default withTranslation()(XentryDealerSettings);
